import { TableRow } from '@sam/components';
import { NavigateFunction } from 'react-router-dom';
import { BusinessArea } from 'shared';
import { Language } from 'shared/src/Language/Language.types';
import { CustomerFeedbackEntry } from 'shared/src/customerFeedbackEntry/CustomerFeedbackEntry.types';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

/**
 * Util method to convert feedbackEntries into tableRows
 * @param entries to convert
 * @param navigate navigateFunction to handle edit click
 * @returns Array of TableRows
 */
export const convertFeedbackEntriesIntoTableEntries = (
  entries: CustomerFeedbackEntry[],
  navigate: NavigateFunction,
  areas: BusinessArea[],
): TableRow[] => {
  return entries.map((entry) => ({
    id: entry.id,
    onClick: () => navigate('/customer/feedback/edit', { state: { entry } }),
    content: [
      entry.title,
      Array.from(
        new Set(
          areas.filter((area) => entry.areaIds.includes(area.id)).map((area) => area.name),
        ).values(),
      ).join(', '),
      new Date(entry.createDate).toLocaleDateString('de-DE') || '-',
      entry.lastUpdate ? new Date(entry.lastUpdate).toLocaleDateString('de-DE') : '-',
      <IconComponent
        type={IconType.EDIT}
        width={30}
        onClick={(evt) => {
          evt.stopPropagation();
          navigate('/customer/feedback/edit', { state: { entry } });
        }}
      />,
    ],
  }));
};

/**
 * Util method to generate an empty customerFeedbackEntry
 * @param override partial feedback entry to adjust the created object
 * @returns  created customerFeedbackEntry
 */
export const generateEmptyCustomerFeedbackEntry = (
  override?: Partial<CustomerFeedbackEntry>,
): CustomerFeedbackEntry => ({
  id: undefined!,
  createDate: new Date(),
  lastUpdate: new Date(),
  createdBy: undefined!,
  disabled: false,
  names: new Map<Language, string>(),
  title: '',
  updatedBy: undefined,
  areaIds: [],
  ...override,
});
